/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
	HideSnackbar,
	ShowSnackbar,
	SNACKBAR_HIDE,
	SNACKBAR_SHOW,
	SnackbarNotificationActionTypes
} from './SnackbarNotificationActionTypes';
import { SnackbarAction } from './SnackbarNotification.actions';

export interface SnackbarNotificationState {
	snackbarAction: SnackbarAction;
	showSnackbar: boolean;
}

export const initialState: SnackbarNotificationState = {
	snackbarAction: { message: '', type: undefined, url: undefined },
	showSnackbar: false
};

const showSnackbar = (state: SnackbarNotificationState, action: ShowSnackbar): SnackbarNotificationState => {
	return {
		...state,
		showSnackbar: true,
		snackbarAction: action.payload
	};
};

const hideSnackbar = (state: SnackbarNotificationState, action: HideSnackbar): SnackbarNotificationState => {
	return {
		...state,
		showSnackbar: false
	};
};

export function snackbarNotificationReducer(
	state = initialState,
	action: SnackbarNotificationActionTypes
): SnackbarNotificationState {
	switch (action.type) {
		case SNACKBAR_SHOW: {
			return showSnackbar(state, action);
		}
		case SNACKBAR_HIDE: {
			return hideSnackbar(state, action);
		}
		default:
			return state;
	}
}

export default snackbarNotificationReducer;
